<!-- 互动卡片组件库 -->
<template>
  <div class="interaction-card-container">
    <!-- 使用 Vant Grid 组件布局 -->
    <img :src="imagePath" alt="" style="width: 100%" />
  </div>
</template>

<script>
export default {
  name: "RightPanelModuleStyle",
  props: {
    datas: Object,
    imagePath: String,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
// 外层容器保留原有宽度和盒模型设置
.interaction-card-container {
  width: 100%;
  box-sizing: border-box;
  padding: 3px 5px;
  .interaction-card-wrapper {
    border-radius: 10px;
    .interaction-card-content {
      width: 100%;
      box-sizing: border-box;
      padding: 0 5px 5px 5px;
    }
    .card-content {
      .interaction-card-title {
        margin: 0 0 8px 0;
      }
    }
    .button-container {
    }
  }
}
</style>
